<template>
  <v-container fluid>
    <v-card flat color="background">
      <v-card-title primary-title>Are you sure you want to delete the location?</v-card-title>
      <v-card-subtitle></v-card-subtitle>
      <v-card-text>
        <p>
          <span class="font-weight-bold">WARNING!</span> This action is not reversible. Please be sure that you really don't need this location anymore.
        </p>
        <v-text-field v-model="userAgreeToDelete" label="Enter 'DELETE' to delete this location."></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!confirmDelete" @click="deleteLocation" color="error">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { LocationAPI } from '../../../clients/locations/locations.api'
export default {
  data() {
    return {
      userAgreeToDelete: ''
    }
  },
  methods: {
    async deleteLocation() {
      if (this.confirmDelete) {
        try {
          LocationAPI.deleteLocation({ locationId: this.$route.params.id })
        } catch (error) {
          return console.log(error)
        }
        this.$router.push('/locations')
        this.swal({ title: 'Success', text: 'Location Deleted Successfully.' })
      }
    }
  },
  computed: {
    confirmDelete() {
      return this.userAgreeToDelete === 'DELETE'
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
